import React from 'react';
import convertMinutesIntoTime from 'js/helpers/convertMinutesIntoTime';
import DataValidator from 'js/components/Common/DataValidator/DataValidator';

import classes from './WatchTime.module.pcss';

export interface Props {
    data: string
}

const WatchTime = ({data}: Props) => (
    <DataValidator data={data?.length > 0}>
        <span className={classes.WatchTime}>{convertMinutesIntoTime(parseInt(data))}</span>
    </DataValidator>
);

export default WatchTime;
